<script lang="ts" setup>
  import { Library } from "~/entities/Library";
  import type { LibraryContent } from "~/entities/LibraryContent";

  interface Props {
    contents: LibraryContent[];
    selectedLibrary: Library;
  }
  const props = defineProps<Props>();

  const emit = defineEmits(["clickLibraryContent"]);

  const localContents = ref<LibraryContent[]>(props.contents);

  const isLastWithChildren = (index: number, content: LibraryContent) => {
    if (content.isOpenDirectory && content.directoryContents?.length > 0) {
      return false;
    }
    return localContents.value.length - 1 === index;
  };

  const isLast = (index: number, contents: LibraryContent[]) => {
    if (contents.length === 0) {
      return true;
    }
    return contents.length - 1 === index;
  };

  const onClickLibraryContent = (content: LibraryContent) => {
    if (content.isDirectory) {
      content.isOpenDirectory = !content.isOpenDirectory;
    } else {
      emit("clickLibraryContent", content);
    }
  };

  watch(
    () => props.contents,
    newContents => {
      localContents.value = newContents;
    },
    { immediate: true },
  );
</script>
<template>
  <div v-for="(content, index) in localContents" :key="index">
    <MoleculesLibraryListItem
      :content="content"
      :selected-library="selectedLibrary"
      :index="index"
      :is-last="isLastWithChildren(index, content)"
      @click-library-content="onClickLibraryContent"
    />
    <template v-if="content.isOpenDirectory && content.directoryContents?.length > 0">
      <div v-for="(childContent, childIndex) in content.directoryContents" :key="childIndex">
        <MoleculesLibraryListItem
          :content="childContent"
          :selected-library="selectedLibrary"
          :index="childIndex"
          :parent-index="index"
          :is-last="isLast(index, localContents) && isLast(childIndex, content.directoryContents)"
          @click-library-content="onClickLibraryContent"
        />
      </div>
    </template>
  </div>
</template>
<style lang="scss" scoped></style>
